import styled from "styled-components";
import * as CommonTypes from "../../../types/common.types"
import { countries } from "countries-list";
import { MdEdit, MdMonetizationOn } from "react-icons/md";
import { IoPersonAddOutline } from "react-icons/io5";
import { FaList } from "react-icons/fa";
import { useAdmin } from "../../../context/admin";
import removeTimezone from "../../../utils/removeTimezone";
import { mobile } from "../../../styles/responsive";
import { FaMoneyBill1Wave, FaTrash } from "react-icons/fa6";
import Checkbox from "../../common/Checkbox";

interface ListInterface {
    list: CommonTypes.TripReservation[]
    setList: Function
}

export default function List({
    list,
    setList
}: ListInterface) {
    const { setRegisterPassengersTripId, setRegisterCostsTripId, 
        setRequirementsTripId, setConfirmUnassignReservationId, setEditPassengerReservationId,
        setCreatePaymentReservationId,
        user } = useAdmin()

    return (
        <Main>
            {
                list.map((trip, idx) => {
                    if (!trip.trip_date) return <></>
                    const date = removeTimezone(trip.trip_date.toString())
                    console.log(date)
                    return (
                        <div className={"tour" + (trip.is_closed ? " closed" : "")} key={idx}>
                            <div className="header">
                                <div className="name">
                                    <span>
                                        {trip.tour_id}
                                    </span>
                                    <span>
                                        {trip.trip_date && date}
                                    </span>
                                    <span>
                                        {trip.trip_time}
                                    </span>
                                </div>
                                <div className="actions">
                                    <button className="request"
                                    title="Request Passengers"
                                    onClick={() => {
                                        setRegisterPassengersTripId(trip.id)
                                    }}
                                    >
                                        <IoPersonAddOutline/>
                                    </button>
                                    <button className="costs"
                                    title="Register costs"
                                    onClick={() => {
                                        setRegisterCostsTripId(trip.id)
                                    }}
                                    >    
                                        <MdMonetizationOn/>
                                    </button>
                                    <button className="requirements"
                                    title="Requirements"
                                    onClick={() => {
                                        setRequirementsTripId(trip.id)
                                    }}
                                    >
                                        <FaList/>
                                    </button>
                                </div>
                            </div>
                            <div className="sub-header">
                                <div className="name">
                                    <span>
                                        Driver: {trip.driver?.name} / {trip.driver?.rut_passport}
                                    </span>
                                </div>
                            </div>
                            <div className="sub-header">
                                <div className="name">
                                    <span>
                                        Guider: {trip.guider?.name} / {trip.guider?.rut_passport}
                                    </span>
                                </div>
                            </div>
                            <div className="sub-header">
                                <div className="name">
                                    <span>
                                        {trip.car?.brand} {trip.car?.model}: {trip.car?.license_plate}
                                    </span>
                                </div>
                            </div>
                            <TableWrapper>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th style={{width: '50px'}}>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th style={{width: '70px'}}>Age</th>
                                            <th>Born</th>
                                            <th>Remark</th>
                                            <th>Traspassed From</th>
                                            <th>Price</th>
                                            <th>Tickets</th>
                                            <th>Abono tour</th>
                                            <th>Abono entrada</th>
                                            <th>Deuda</th>
                                            <th style={{width: '80px'}}>Tour paid</th>
                                            <th style={{width: '80px'}}>Pass paid</th>
                                            <th style={{width: '50px'}}></th>
                                            <th style={{width: '50px'}}></th>
                                            <th style={{width: '50px'}}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            trip.reservations?.map((reservation, idx) => {
                                            return (
                                                    <tr key={idx}>
                                                        <td>{idx + 1}</td>
                                                        <td>{reservation.passenger?.name}</td>
                                                        <td><a href={`mailto:${reservation.passenger?.email}`}>{reservation.passenger?.email}</a></td>
                                                        <td>{reservation.passenger?.age} y/o</td>
                                                        <td>{countries[reservation.passenger?.nationality as keyof typeof countries]?.name}</td>
                                                        <td>{reservation.remark}</td>
                                                        <td>{reservation.passenger?.traspassed_from || (user?.user.agency_id !== reservation.agency.id && reservation.agency.name)}</td>
                                                        <td>{reservation.traspass_price || reservation.price}</td>
                                                        <td>{reservation.tickets}</td>
                                                        <td>
                                                            {
                                                            reservation.agency.id !== user?.user.agency_id &&
                                                            reservation.payments?.reduce((acc, payment) => acc + (payment.amount || 0), 0)
                                                        }
                                                        </td>
                                                        <td>
                                                            {
                                                            reservation.agency.id !== user?.user.agency_id &&
                                                            reservation.payments?.reduce((acc, payment) => acc + (payment.amount_tickets || 0), 0)
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                            reservation.agency.id !== user?.user.agency_id &&
                                                            reservation.traspass_price + reservation.tickets - reservation.payments?.reduce((acc, payment) => acc + (payment.amount || 0) + (payment.amount_tickets || 0), 0)
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                reservation.agency.id !== user?.user.agency_id &&
                                                                <Checkbox
                                                                containerStyle={{display: 'flex', justifyContent: 'center'}}
                                                                checked={reservation.payments?.reduce((acc, payment) => acc + (payment.amount || 0), 0) >= reservation.traspass_price!}
                                                                />
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                reservation.agency.id !== user?.user.agency_id &&
                                                                <Checkbox
                                                                containerStyle={{display: 'flex', justifyContent: 'center'}}
                                                                checked={reservation.payments?.reduce((acc, payment) => acc + (payment.amount_tickets || 0), 0) >= reservation.tickets!}
                                                                />
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                reservation.agency.id !== user?.user.agency_id &&
                                                                <button className="info"
                                                                onClick={() => setCreatePaymentReservationId(reservation.id)}
                                                                >
                                                                    <FaMoneyBill1Wave />
                                                                </button>
                                                            }
                                                        </td>
                                                        <td>
                                                            <button
                                                            className="info"
                                                            onClick={() => setEditPassengerReservationId(reservation.id)}
                                                            >
                                                                <MdEdit />
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button
                                                            className="info"
                                                            onClick={() => setConfirmUnassignReservationId(reservation.id)}
                                                            ><FaTrash/></button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </TableWrapper>
                        </div>
                    )
                })
            }
        </Main>
    )
}

const Main = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 90%;
    margin: auto;
    margin-top: 15px;
    
    ${mobile({
        width: '100%',
        padding: '0 10px'
    })}
    
    overflow: unset;
    .tour.closed .header, .tour.closed .sub-header {
        background-color: ${props => props.theme.lightGreen};
        color: ${props => props.theme.white};
    }
    .tour {
        background-color: ${props => props.theme.whiteBackground};
        border-radius: 10px;
        box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
        
        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 10px 10px 0 0;
            position: relative;
            height: 40px;
            background-color: ${props => props.theme.black};
            color: ${props => props.theme.white};
            padding: 0 10px;
            
            ${mobile({
                flexDirection: 'column',
                height: 'auto',
                padding: '12px',
                gap: '10px'
            })}
            
            .name {
                flex: 1;
                text-align: center;
                display: flex;
                gap: 10px;
                justify-content: center;
                
                ${mobile({
                    textAlign: 'left',
                    width: '100%',
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                })}
                
                span {
                    ${mobile({
                        fontSize: '13px'
                    })}
                }
            }
            
            .actions {
                height: 100%;
                display: flex;
                gap: 5px;
                padding: 5px;
                
                ${mobile({
                    width: '100%',
                    justifyContent: 'center'
                })}
                
                button {
                    height: 100%;
                    width: 50px;
                    font-size: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    color: ${props => props.theme.white};
                    transition: all 0.2s ease;
                    
                    ${mobile({
                        width: '40px',
                        height: '35px',
                        fontSize: '16px'
                    })}
                    
                    &:hover {
                        transform: translateY(-2px);
                    }
                    
                    &:active {
                        transform: translateY(0);
                    }
                }
                
                button.request {
                    background-color: ${props => props.theme.blue};
                }
                
                button.costs {
                    background-color: ${props => props.theme.lightGreen};
                }
                
                button.requirements {
                    background-color: ${props => props.theme.yellowDark};
                }
            }
        }
        
        .sub-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 0;
            position: relative;
            min-height: 40px;
            background-color: ${props => props.theme.black};
            color: ${props => props.theme.white};
            padding: 0 10px;
            border-top: 1px solid rgba(255, 255, 255, 0.1);
            
            ${mobile({
                padding: '8px 12px'
            })}
            
            .name {
                flex: 1;
                text-align: center;
                display: flex;
                gap: 10px;
                justify-content: center;
                
                ${mobile({
                    textAlign: 'left',
                    width: '100%',
                    justifyContent: 'flex-start'
                })}
                
                span {
                    ${mobile({
                        fontSize: '12px'
                    })}
                }
            }
        }
    }
`

const TableWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: visible;
    
    ${mobile({
        overflowX: 'scroll',
        '-webkit-overflow-scrolling': 'touch'
    })}
`

const Table = styled.table`
    border-collapse: collapse;
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 1200px;
    
    ${mobile({
        minWidth: '900px'
    })}
    
    thead {
        width: 100%;
        background-color: #FFFFFF;
        position: sticky;
        top: 0;
        z-index: 10;
    }
    
    th {
        font-weight: 500;
        font-size: 13px;
        padding: 12px 8px;
        background-color: #f9fafb;
        border-bottom: 2px solid #e5e7eb;
        white-space: nowrap;
        text-align: center;
        
        ${mobile({
            fontSize: '12px',
            padding: '10px 6px'
        })}
    }
    
    td {
        text-align: center;
        padding: 10px 8px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 13px;
        white-space: nowrap;
        
        ${mobile({
            fontSize: '12px',
            padding: '8px 6px'
        })}
        
        a {
            color: ${props => props.theme.blue};
            text-decoration: none;
            
            &:hover {
                text-decoration: underline;
            }
        }
        
        .flag {
            width: 30px;
        }
        
        > button {
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            background-color: ${props => props.theme.white};
            border: 1px solid ${props => props.theme.black};
            border-radius: 5px;
            cursor: pointer;
            transition: all 0.2s ease;
            
            &:hover {
                transform: scale(1.05);
            }
            
            &:active {
                transform: scale(0.95);
            }
        }
        
        > button.selected {
            background-color: ${props => props.theme.blueLight};
        }
        
        button.info {
            border: none;
            background: none;
            font-size: 18px;
            cursor: pointer;
            color: ${props => props.theme.blue};
            transition: all 0.2s ease;
            
            &:hover {
                transform: scale(1.1);
                color: ${props => props.theme.blueDark};
            }
        }
    }
    
    tr {
        height: auto;
        width: 100%;
        
        &:hover {
            background-color: #f9fafb;
        }
    }
`